export enum TabDisplayStyle {
  Accordion = "Accordion",
  Normal = "Normal",
  Separate = "Separate",
  AccordionHeader = "AccordionHeader",
  AccordionChildren = "AccordionChildren"
}